import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { Messages } from "@stockcare-models/Messages";
import { MessagesService } from "@stockcare-services/messages-service/messages.service";
import { NotificationService } from "@stockcare-services/notification-service/notification.service";



@Component({
  standalone: false,
  selector: "messages-detail-dialog",
  templateUrl: "./messages-detail-dialog.component.html",
  styleUrls: ["./messages-detail-dialog.component.scss"],
})
export class MessagesDetailDialogComponent implements OnInit {
  form: FormGroup;
  dataSource = new MatTableDataSource<Messages>([]);
  displayedColumns: string[] = [
    "id",
    "createDateTime",
    "messageType"
  ];
  selectedMessageId: number = 0;
  selectedMessage: string = '';
  messageContent: string = '';
  formattedText: string = '';
  
  constructor(
    private modelReference: MatDialogRef<MessagesDetailDialogComponent>,
    private notify: NotificationService,
    private messagesService: MessagesService,
  ) {}

  
  
  ngOnInit() {
    this.buildForm();
    this.getMessages();
  }

   private buildForm() {
    this.form = new FormGroup({
      message: new FormControl(),
    });
  }

  getMessages(){
    this.messagesService.getMessages().subscribe(
       (response) => {
         this.dataSource = new MatTableDataSource<Messages>(
                  response
                );
      });
  }
  
  cancel() {
    this.modelReference.close(false);
  }

  selectMessage(row: any) {
    this.selectedMessageId = row.id;
    this.selectedMessage = row;
    
    if(row.message.includes('=>>')) 
    {
      row.message = row.message.replace('\r\n', '');
      row.message = row.message.replace(/\t/g, '');
      row.message = row.message.replace(/;/g, '\r\n'); 

      this.formattedText = row.message.split('=>>')[1];
      try {
        const parsed = JSON.parse(this.formattedText);
        const entry = parsed.RETURN && Array.isArray(parsed.RETURN) ? parsed.RETURN[0] : null;
        if (entry) {
          this.formattedText = Object.entries(entry)
            .map(([key, value]) => `${key}: ${value}`)
            .join('\n');
        }
        this.form.controls.message.setValue(row.message.split('=>>')[0] + '\r\n==============SAP Response===============\r\n' + this.formattedText);
      } catch (e) {
        this.form.controls.message.setValue(this.formattedText);
      }
    }   
    else
      this.form.controls.message.setValue(row.message);


    if(!row.isRead) {
      row.isRead = true;
      this.messagesService.readMessage(row.id).subscribe();
    }
    
  }

}
